/*
 * @Description: 路由配置
 * @Author: youme
 * @LastEditors: YTH
 * @Date: 2020-06-10 13:23:58
 * @LastEditTime: 2025-09-15 15:04:50
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('@/views/Product')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/views/Contact')
  },
  {
    path: '/ecologicalCooperation',
    name: 'ecologicalCooperation',
    component: () => import('@/views/EcologicalCooperation')
  },
  {
    path: '/companyvalue',
    name: 'companyvaluemes',
    component: () => import('@/views/CompanyValue')
  },
  {
    path: '/lawstatement',
    name: 'lawstatement',
    component: () => import('@/views/LawStatement')
  },
  {
    path: '/product-mom',
    name: 'ProductMom',
    component: () => import('@/views/ProductMom')
  },
  {
    path: '/product-detail/:type',
    name: 'ProductDetail',
    component: () => import('@/views/ProductMom/ProductAction'),
    props: true
  },
  {
    path: '/product-mes',
    name: 'ProductMes',
    component: () => import('@/views/ProductMes')
  },
  {
    path: '/product-fic',
    name: 'ProductFic',
    component: () => import('@/views/ProductFic')
  },
  {
    path: '/product-dpm',
    name: 'ProductDpm',
    component: () => import('@/views/ProductDpm')
  },
  {
    path: '/product-ems',
    name: 'ProductEms',
    component: () => import('@/views/ProductEms')
  },
  {
    path: '/product-wms',
    name: 'ProductWms',
    component: () => import('@/views/ProductWms')
  },
  {
    path: '/product-eam',
    name: 'ProductEam',
    component: () => import('@/views/ProductEam')
  },
  {
    path: '/product-qms',
    name: 'ProductQms',
    component: () => import('@/views/ProductQms')
  },
  {
    path: '/company-profile',
    name: 'CompanyProfile',
    component: () => import('@/views/CompanyProfile')
  },
  {
    path: '/company-honor',
    name: 'CompanyHonor',
    component: () => import('@/views/CompanyHonor')
  },
  {
    path: '/customercase',
    name: 'CutomerCase',
    component: () => import('@/views/CutomerCase')
  },
  {
    path: '/customercase-detail/:id',
    name: 'CutomerCaseDetail',
    component: () => import('@/views/CutomerCase/CutomerCaseDetail'),
    props: true
  },
  {
    path: '/customercasedetail',
    name: 'CutomerCaseDetailMore',
    component: () => import('@/views/CutomerCaseDetailMore'),
    props: true,
    meta: { noForceBlueHead: true }
  },
  {
    path: '/core-value',
    name: 'CoreValue',
    component: () => import('@/views/CoreValue')
  },
  {
    path: '/company-news',
    name: 'CompanyNews',
    component: () => import('@/views/CompanyNews')
  },
  {
    path: '/company-news-del/:id',
    name: 'CompanyNewsDel',
    component: () => import('@/views/CompanyNews/CompanyNewsDel'),
    props: true
  },
  {
    path: '/industry-news',
    name: 'IndustryNews',
    component: () => import('@/views/IndustryNews')
  },
  {
    path: '/industry-news-del/:id',
    name: 'IndustryNewsDel',
    component: () => import('@/views/IndustryNews/IndustryNewsDel'),
    props: true
  },
  {
    path: '/recruit',
    name: 'Recruit',
    component: () => import('@/views/Recruit')
  },
  {
    path: '/recruit-detail/:id',
    name: 'RecruitDetail',
    component: () => import('@/views/Recruit/RecruitDetail'),
    props: true
  },
  {
    path: '/common-problem/:type',
    name: 'CommonProblem',
    component: () => import('@/views/CommonProblem'),
    props: true
  },
  {
    path: '/industry-info/:id',
    name: 'IndustryInfo',
    component: () => import('@/views/IndustryInfo'),
    props: true
  },
  {
    path: '/ouradvantage',
    name: 'OurAdvantage',
    component: () => import('@/views/OurAdvantage')
  },
  {
    path: '/system-display',
    name: 'SystemDisplay',
    component: () => import('@/views/SystemDisplay')
  },
  {
    path: '/website-map',
    name: 'WebsiteMap',
    component: () => import('@/views/WebsiteMap')
  },
  {
    path: '/solution-case-del/:id',
    name: 'SolutionCase',
    component: () => import('@/views/SolutionCases/SolutionCaseDel'),
    props: true
  },
  {
    path: '/solutioncase-del',
    name: 'SolutionCaseDel',
    component: () => import('@/views/SolutionCaseDel'),
    props: true
  },
  {
    path: '/free-trial-phone',
    name: 'FreeTrialPhone',
    component: () => import('@/views/FreeTrialPhone')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (from.name !== to.name) {
    setTimeout(_ => { window.scrollTo(0, 0) }, 500)
  }
  next()
})

export default router
